import Vue from 'vue';

export default Vue.extend({
  name: 'customAgGridNoRowsOverlay',
  template: `
    <div
      class="flex flex-col justify-center items-center w-full"
      style="max-width: 500px; row-gap: 12px;"
      :style="{
      'padding-top': params.paddingTop || '56px',
      'margin-top': params.marginTop || '55px',
      }"
      >
      <h3
        v-if="params.title"
        class="font-bold">
        {{ params.title }}
      </h3>

      <p v-if="params.text">
        {{ params.text }}
      </p>

      <vs-button
        v-if="params.buttonText && params.actionButtonClicked"
        class="mt-5"
        @click="params.actionButtonClicked">
        {{ params.buttonText }}
      </vs-button>
    </div>
    `,
  data() {
    return {};
  },
  beforeMount() {},
  mounted() {},
  methods: {},
});
